module.exports = __webpack_public_path__ + "img/contest_banner.737f7064.jpg";